import React, { useEffect, useState } from 'react'
import { fechaActual } from '../../../hooks/UseDate'
import { postActualizarProcirLiquidacionQx, postActualizarTablatmpfac, postDataParaInserttmpfac, postDataPDFLiquidarUnProcedimineto, postDeleteTMPTMPLiquidacionQx, postInsertDataTMPFAC1, postLiquidacionForLiqCod } from '../../../services/PaginaRuta'
import TablaLiquidarUnProcedimiento from './TablaLiquidarUnProcedimiento'
import {PDFDownloadLink} from '@react-pdf/renderer'
import ModalAntesDescargarPDFLiquidacionQx from './ModalAntesDescargarPDFLiquidacionQx'
import Loading from '../../Loading'
import ModalValidarSIesFacturableOHojaGastoLiquidacionesQx from './ModalValidarSIesFacturableOHojaGastoLiquidacionesQx'

const ModalLiquidarUnProcedimiento = ({setmodalOnLiquidarUnProcedimiento,nombreProcedimiento, codigoProcedimiento,dataUser }) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));  
  const [dataHonorario, setdataHonorario]=useState([])
    const [dataInsert, setdataInsert]=useState([])
    const [loading,setloading]=useState(false)
    const [errorSeleccionarFacturableHojadeGasto, seterrorSeleccionarFacturableHojadeGasto]=useState('Seleccionar tipo')
    const [hojaGastoOFacturable, sethojaGastoOFacturable]=useState('')
    const [modalOnValidarHojaGasto, setmodalOnValidarHojaGasto]=useState(false)
    const [validarButtonDescargaPDF, setvalidarButtonDescargaPDF]=useState(true)
    const [isFacturable, setisFacturable]=useState('')
    const [dataPDF, setdataPDF]=useState({
      CrgCnt0:"",
      CrgCod:"",
      CrgEst:"",
      EmpDsc:"",
      ForLiqCod:"",
      ForLiqDsc:"",
      ForLiqVlHn:"",
      ForLiqcar:"",
      HomProDsc:"",
      MECTope:"",
      MENNIT:"",
      MENOMB:"",
      MaeVlrFact:"",
      MaeVlrNoC:"",
      MaeVlrReg:"",
      MeCnsCnt:"",
      PTCntUvr:"",
      PTCodi:"",
      PTDesc: "",
      ProCirCod:"",
      ProCons:"",
      ProEmpCod:"",
      ProFec:"",
      ProFecF:"",
      ProHorF:"",
      ProHorI:"",
      ProMCDpto:"",
      ProSedQr:"",
      ProSit:"",
      TFCscP:"",
      TFcCodCam:"",
      TFcCodPab:"",
      TipHer:"",
      TrfCod:"",
      ViaCod:"",
      ViaIng:""
    })
    const [valorTotalLiquidacionQx,setvalorTotalLiquidacionQx]=useState('')
    //let totalValorLiquidacion = 0
    const handleCancelClick=()=>{
        setmodalOnLiquidarUnProcedimiento(false)
    }
    // const handleOnclickLiquidar=()=>{

    // }
    const handleOnsubmitGuardarLiquidacion=()=>{
      //e.preventDefault();
      //insertar data en la tabla TMPFAC1
     
      
        // const actualizartmpfac={
        //   TFCedu:dataUser.MPCedu,
        //   TFTDoc:dataUser.MPTDoc,
        //   TmCtvIng:dataUser.ProCtvIn,
        //   TFUscP: `${parseInt(dataInsert.TFCscP)}`,
        //   TFUlcAC:'1',
        //   TFCnTQx:'1'
        // }
        // postActualizarTablatmpfac(actualizartmpfac).then((res)=>{
        //   console.log(res.data,'Tablatmpfac')

          //Actualizar el procir
          if(errorSeleccionarFacturableHojadeGasto === ''){
            const actualizarProcir={
              ProEmpCod:usuarioInfo.Empresa ,
              ProMCDpto:usuarioInfo.Sede,
              ProCirCod: dataUser.ProCirCod,
              ProEsta:'5'
            }
            console.log(actualizarProcir,'actualizarProcir actualizarProcir')
            postActualizarProcirLiquidacionQx(actualizarProcir).then((res)=>{
              console.log(res.data,'Actualizar procir')
              //////
              const insertDataTMPFAC1={
                TFCedu: dataUser.MPCedu,
                TFTDoc: dataUser.MPTDoc,
                TmCtvIng: dataUser.ProCtvIn,
                TFNitP: dataUser.ProEPS,
                TFFchP: "2023-28-02 12:51:33.000", //PREGUNTAR
                TFTipP: "1",
                TFProc: "2",
                TFPerA: "6",
                TFPrC1: dataUser.CrgCod,
                TFVaTP: "109056.00", //PREGUNtar
                TFNumA: "                                                            ",
                TFNomA: "                              ",
                TFUPro: usuarioInfo.UsuarioEncriptado,
                TFUVRVLR: "80",
                TFUVRCOD: "01 ",
                TFCanpr: "1",
                TFCopa: "0",
                TFCoMo: "0",
                TFinte: "109056.00", //Valor total integral
                TFPCSO: "INDV",
                TFOpcn: "0",
                TFPCodCCs: usuarioInfo.Sede,
                TFPCodSCC: dataUser.CNCCOD,
                TFPTpoTrn: hojaGastoOFacturable, //tipo de transaccion, hoja de gasto o facturable
                TFPFchReg: "2023-26-01 00:00:00.000",
                TFPinte: ".000000000",
                TFCodPab: "5",
                TFCoRecar: "N",
                TFPCodEmp: "1 ",
                TFDiPr: "R101 ", //Descripcion Dx Previo
                TFAgrCir: "1",  
                TFDiPP: "R101 ",  //Descripcion Dx Posterior
                TFPHoMe: "1.0000", //PREGUNTAR
                MMcoM1: "     ",
                MECoM1: "999",
                TFDiCo: "     ",
                TFVlrTot: valorTotalLiquidacionQx,//"3322580.00",
                TFVias: "0",
                TFEspe: "0",
                TFNGrp: "01 ",
                TFPNDCT: "          ",
                TFHISCSEC: dataInsert.TFHISCSEC,//"225",
                TFEstaAnu1: "N",
                TFCodCir: dataUser.ProCirCod,
                TFPPPCod: "         ",
                TFOrdMan: "N",
                TFPPorIva: ".000000000",
                TFPVlrSIv: "109056.00", //PREGUNTAR
                TFOrdLiq: "0",
                TFCnaqX: "1",
                TFIMPPRC: ".00",
                TFPCODIMPP: "        ",
                ForLiqCod: "01",
                HnrCod: "01",
                TmpUsr: ",:<?<::>",
                TmpClPr : "2",
                CodigoFormaLiquidacion: "01",
                CodPortafolioProc: "39",
                CodProcedimiento: dataUser.CrgCod,
                NumContrato : dataUser.ProEPS
              }
                console.log(insertDataTMPFAC1,'insertDataTMPFAC1')
                postInsertDataTMPFAC1(insertDataTMPFAC1).then((res)=>{
                console.log(res.data,'insertar data TMPFAC1')
                //Delete TMPTMP
                const DeleteTMPTMP={
                  TmpUsr:usuarioInfo.UsuarioEncriptado,
                  TmpCedu: dataUser.MPCedu,
                  TmpTDoc:dataUser.MPTDoc,
                  TmpClPr:'2'
                }
                postDeleteTMPTMPLiquidacionQx(DeleteTMPTMP).then((res)=>{
                  console.log(res.data,'delete')
                
              })
            })
          })
          }else{
            setmodalOnValidarHojaGasto(true)
          }
          
      //})
    }
    useEffect(()=>{
      setloading(false)
        const forli={
            ForLiqCod:'01'
        }
        postLiquidacionForLiqCod(forli).then((res)=>{
            console.log(res.data,'forli')
            //setdataHonorario(res.data)
        })
        console.log(dataUser,'dataUserh')
        ///
        const dataInsert={
          TFCedu:dataUser.MPCedu,
          TFTDoc:dataUser.MPTDoc,
          TmCtvIng:dataUser.ProCtvIn
        }
        postDataParaInserttmpfac(dataInsert).then((res)=>{
          console.log(res.data,'datainsertt')
          setdataInsert(res.data[0])
        })
        /////data insert y pdf
        const dataPDF={
          TFCedu:dataUser.MPCedu,
          TFTDoc: dataUser.MPTDoc,
          TmCtvIng: dataUser.ProCtvIn,
          ProEmpCod:usuarioInfo.Empresa,
          MENNIT:dataUser.ProEPS,
          ProMCDpto:usuarioInfo.Sede,
          ProCirCod:dataUser.ProCirCod,
          CrgEst:'S',
          MeCfcha1: dataUser.ProFec,
          PRCODI: dataUser.CrgCod,
          ForLiqCod:'01',
          HnrCod:'01',
          //TrfCod:'2',
          CodMed: dataUser.ProPerSep,
          CodigoFormaLiquidacion:'01',
          CodProcedimiento: dataUser.CrgCod,
          NumContrato: dataUser.ProEPS
        }
        console.log(dataPDF,'data antes importante')
        postDataPDFLiquidarUnProcedimineto(dataPDF).then((res)=>{
          console.log(Object.values(res.data),'data importante')
          if(Object.values(res.data)[1]){
            console.log('Entro')
            let totalValorLiquidacion = Object.values(res.data)[1].reduce((acumulador, objeto) => {
              return acumulador + parseInt(objeto.ValorHonorario);
            }, 0);
            console.log(Object.values(res.data)[1],'totall')
            setvalorTotalLiquidacionQx(totalValorLiquidacion)
            setdataHonorario(Object.values(res.data)[1]) 
            setdataPDF(Object.values(res.data)[0])
            setloading(true)
          // if(res.data[0]){
          //   console.log('SI')
          //   setdataPDF(res.data[0])
          // }else{
          //   console.log('NO')
          //   setdataPDF({
          //     CrgEst: "",
          //     ProCirCod: "",
          //     ProMCDpto: "",
          //     ProEmpCod: "",
          //     ProSit: "",
          //     ViaCod: "",
          //     CrgCod: "",
          //     TFcCodPab: "",
          //     TFcCodCam: "",
          //     TFCscP: "",
          //     MeCnsCnt: "",
          //     MaeVlrFact: "",
          //     MaeVlrNoC: "",
          //     MaeVlrReg: "",
          //     MECTope: "",
          //     PTCodi: "",
          //     CrgCnt: "",
          //     ViaIng: "",
          //     PTCntUvr: "",
          //     ForLiqCod: "",
          //     ForLiqVlHn: "",
          //     ProSedQr: "",
          //     ProCons: "",
          //     MENNIT: "",
          //     MENOMB: "",
          //     EmpDsc: "",
          //     PTDesc: "",
          //     HomProDsc: "",
          //     ForLiqDsc: "",
          //     ForLiqcar: ""
          // })
          // } 
          }else{

          }
          
        })
    },[])
    const handleOnChangeFacturableHojaGasto=(e)=>{
      if(e.target.value !== '0'){
        seterrorSeleccionarFacturableHojadeGasto('')
        sethojaGastoOFacturable(e.target.value)
        setvalidarButtonDescargaPDF(false)
      }else{
        seterrorSeleccionarFacturableHojadeGasto('Seleccionar tipo')
        setvalidarButtonDescargaPDF(true)
      }

      if(e.target.value === 'F'){
        setisFacturable('Si')
      }else if(e.target.value === 'H'){
        setisFacturable('No')
      }else{
        setisFacturable('')
      }
    }

    ///nuevo
    const [selectedRows, setSelectedRows] = useState([]);
    console.log(selectedRows,'selectedRows')
  function handleRowSelect(rowId) {
    if (selectedRows.includes(rowId)) {
      setSelectedRows(selectedRows.filter(id => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto "
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] mx-auto relative w-auto pointer-events-none  bg-[#f4f6fa]">
        <div className=" overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Liquidación de un procedimiento Cirugía
            </h5>
            <button
              type="button"
              onClick={handleCancelClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          {/* {
            loading? <>
            <Loading/>
            <div className="py-40"></div>
            </>
            : */}

          <div className="flex-auto overflow-y-auto relative p-4">
          <form onSubmit={handleOnsubmitGuardarLiquidacion}>
              <div >
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Tipo Documento
                    </label>
                    <input
                      defaultValue={dataUser.MPTDoc}
                      //value={seleccionarMedico.MedCod}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número Documento
                    </label>
                    <input
                      disabled={true}
                      defaultValue={dataUser.MPCedu}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número Documento
                    </label>
                    <input
                      disabled={true}
                      defaultValue={dataUser.MPNOMC}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  
                </div>
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Codigo
                    </label>
                    <input
                      defaultValue={dataUser.ProCirCod}
                      //value={seleccionarMedico.MedCod}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Contrato
                    </label>
                    <input
                      disabled={true}
                      defaultValue={dataUser.ProEPS}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Fecha
                    </label>
                    <input
                      disabled={true}
                      defaultValue={dataUser.ProFec.split(' ')[0]}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  
                </div>
              </div>
            </form>
            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-1 inline-block min-w-full ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center bg-gray-200">
                        <thead className="">
                          <tr>
                          <th
                              scope="col"
                              className="text-sm font-medium text-gray-900"
                            >
                              
                            </th>
                          
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Sel
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cons
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              A.Qx
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Agru
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Proced Qx
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Descripción
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Tipo
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Via
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Esp.Ciru
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Opción
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Orden M
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              C. Costo
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              N° Autorización
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr className="divide-y divide-slate-700">
                                <td></td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
                                    
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                   1
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                   1
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                   MULT
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                   {codigoProcedimiento}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
                                   {nombreProcedimiento}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">                                    
                                    <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                        <select 
                                        onChange={handleOnChangeFacturableHojaGasto} 
                                        className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                        border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 
                                        aria-label="Default select example">
                                            <option value="0" >-------------</option>
                                            <option value="F" >Facturable</option>
                                            <option value="H" >Hoja de Gasto</option>
                                        </select>
                                    </div>
                                    </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">                                    
                                    <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                        <select  className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                        border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 
                                        aria-label="Default select example">
                                            <option value="6" >-------------</option>
                                            <option value="6" >Unica via</option>
                                            <option value="6" >Diferente via</option>
                                            <option value="6" >Bilateral</option>
                                        </select>
                                    </div>
                                    </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">                                    
                                    <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                        <select  className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                        border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 
                                        aria-label="Default select example">
                                            <option value="6" >-------------</option>
                                            <option value="6" >Igual Especialidad</option>
                                            <option value="6" >Diferente Especialidad</option>                                            
                                        </select>
                                    </div>
                                    </div>
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-8  whitespace-pre-wrap">                                    
                                    <div className="pt-2 w-full ">
                                    <div className="mb-3 ">
                                        <select  className="form-select block w-30 px-2 py-1.5  font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat text-sm
                                        border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 
                                        aria-label="Default select example">
                                            <option value="6" >-------------</option>
                                            <option value="6" >Programada</option>
                                            <option value="6" >Urgencias</option>                                            
                                        </select>
                                    </div>
                                    </div>
                                </td>
                                
                                <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">                                    
                                    <div className="pt-2 ">
                                    <div className="mb-3 w-full">
                                    <input
                                        //defaultValue={seleccionarMedico.MedCod}
                                        //value={seleccionarMedico.MedCod}
                                        //disabled={true}
                                        autoComplete='off'
                                        type="text"
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                     />
                                    </div>
                                    </div>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className='text-red-900'>{errorSeleccionarFacturableHojadeGasto}</td>
                            </tr>
                                
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <h5
            className="text-xl font-medium leading-normal text-gray-800 text-center"
            id="exampleModalScrollableLabel"
          >
            PROCEDIMIENTOS
          </h5> */}
            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-1 inline-block min-w-full ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center bg-gray-200">
                        <thead className="">
                          <tr>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Pro
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cons
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              A.Qx
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cd.Prc
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Procedimiento
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cant
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Honorario
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cod.Med
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Nombre Médico
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cod. Esp
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Especialidad
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              No Fac?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Vr. Hono
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Tmpo
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Participo?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Realizó?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Docto
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Incluido Flq
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Forma Liq
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Vrl. Uvr
                            </th>
                          </tr>
                        </thead>
                        {loading?
                            dataHonorario.map((item,index)=>(
                                <TablaLiquidarUnProcedimiento item={item} key={index} nombreProcedimiento={nombreProcedimiento} codigoProcedimiento={codigoProcedimiento} isFacturable={isFacturable} selectedRows={selectedRows} handleRowSelect={handleRowSelect}/>
                            ))
                            :
                            <tbody className="divide-y divide-slate-700">
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><Loading/></td>
                            </tr>
                            </tbody>
                        }
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-1 inline-block min-w-full ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center bg-gray-200">
                        <thead className="">
                          <tr>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Pro
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cons
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              A.Qx
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cd.Prc
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Procedimiento
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cant
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Honorario
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cod.Med
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Nombre Médico
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cod. Esp
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Especialidad
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              No Fac?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Vr. Hono
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Tmpo
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Participo?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Realizó?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Docto
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Incluido Flq
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Forma Liq
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Vrl. Uvr
                            </th>
                          </tr>
                        </thead>
                        {loading?
                            dataHonorario.map((item,index)=>(
                                <TablaLiquidarUnProcedimiento item={item} key={index} nombreProcedimiento={nombreProcedimiento} codigoProcedimiento={codigoProcedimiento} isFacturable={isFacturable}/>
                            ))
                            :
                            <tbody className="divide-y divide-slate-700">
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><Loading/></td>
                            </tr>
                            </tbody>
                        }
                        
                          {dataHonorario.map(row => (
                            <tr key={row.CodigoHonorario}>
                              <td>
                                {row.DescripcionHonorario}
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedRows.includes(row.CodigoHonorario)}
                                  onChange={() => handleRowSelect(row.CodigoHonorario)}
                                />
                              </td>
                              <td>{row.ValorHonorario}</td>
                            </tr>
                          ))}
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="w-1/3 p-3">
            <button
                type="submit"
                onClick={handleOnclickAgregarMedicoDQ}
                className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Agregar Médico
              </button>
          </div> */}
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                onClick={handleCancelClick}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              {
                validarButtonDescargaPDF?
                <button
                    type="button"
                    onClick={handleOnsubmitGuardarLiquidacion}
                    className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                  >
                    Liquidar
                </button>
                  :
                <PDFDownloadLink document={<ModalAntesDescargarPDFLiquidacionQx dataPDF={dataPDF} dataUser={dataUser} dataHonorario={dataHonorario} valorTotalLiquidacionQx={valorTotalLiquidacionQx}/>} fileName="hjKleDSAiUWOXzYRdqXTIP.pdf">
                    <button
                    type="button"
                    onClick={handleOnsubmitGuardarLiquidacion}
                    className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                  >
                    Liquidar
                  </button>
                </PDFDownloadLink>
              }
              
            </div>
          </div>
          {/* } */}
        </div>
      </div>
      {modalOnValidarHojaGasto? <ModalValidarSIesFacturableOHojaGastoLiquidacionesQx setmodalOnValidarHojaGasto={setmodalOnValidarHojaGasto}/>:null}
    </div>
  )
}

export default ModalLiquidarUnProcedimiento